// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ydwQr","rootNoMargin":"styles_rootNoMargin__16Du_"};